import { Button } from '@ui/components/Button';
import { SignInIcon } from '@ui/icons/SignInIcon/SignInIcon';

import styles from './SessionEndedPage.module.css';

type Props = {
  onContinue?: () => void;
  onLogin?: () => void;
};

export function SessionEndedPage({ onContinue, onLogin }: Props) {
  return (
    <div className={styles.content}>
      <div className={styles.header}>Сессия завершена</div>
      <div className={styles.subTitle}>
        Ваша сессия на ChessOpen Турниры истекла или вы вышли из аккаунта
      </div>
      <div className={styles.buttons}>
        <Button onClick={onContinue}>Продолжить как гость</Button>
        <Button icon={<SignInIcon />} onClick={onLogin}>
          Войти снова
        </Button>
      </div>
    </div>
  );
}
